
import {
    CORE_GET_STATION_REQUEST,
    CORE_GET_STATION_SUCCESS,
    CORE_GET_STATION_FAILURE,

    CORE_GET_STATION_KPI_HOUR_REQUEST,
    CORE_GET_STATION_KPI_HOUR_SUCCESS,
    CORE_GET_STATION_KPI_HOUR_FAILURE,

    CORE_GET_STATION_KPI_DAY_REQUEST,
    CORE_GET_STATION_KPI_DAY_SUCCESS,
    CORE_GET_STATION_KPI_DAY_FAILURE,

    CORE_GET_STATION_KPI_MONTH_REQUEST,
    CORE_GET_STATION_KPI_MONTH_SUCCESS,
    CORE_GET_STATION_KPI_MONTH_FAILURE,

    CORE_GET_STATION_KPI_YEAR_REQUEST,
    CORE_GET_STATION_KPI_YEAR_SUCCESS,
    CORE_GET_STATION_KPI_YEAR_FAILURE,
} from '../types'
import { REQUEST_STATE } from '../types';
const requestState = REQUEST_STATE;

export default {
    station: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_REQUEST:
                return state;
            case CORE_GET_STATION_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_FAILURE:
                return [];
            default:
                return state;
        }
    },
    stationHour: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_KPI_HOUR_REQUEST:
                return state;
            case CORE_GET_STATION_KPI_HOUR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_KPI_HOUR_FAILURE:
                return [];
            default:
                return state;
        }
    },
    stationDay: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_KPI_DAY_REQUEST:
                return state;
            case CORE_GET_STATION_KPI_DAY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_KPI_DAY_FAILURE:
                return [];
            default:
                return state;
        }
    },
    stationMonth: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_KPI_MONTH_REQUEST:
                return state;
            case CORE_GET_STATION_KPI_MONTH_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_KPI_MONTH_FAILURE:
                return [];
            default:
                return state;
        }
    },
    stationYear: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_KPI_YEAR_REQUEST:
                return state;
            case CORE_GET_STATION_KPI_YEAR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_KPI_YEAR_FAILURE:
                return [];
            default:
                return state;
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerStationAPI.js